export const SAME_SITE_STRICT = 'strict';
export const SAME_SITE_LAX = 'lax';

export const COOKIE_LOCAL_DOMAIN = 'localhost';
export const COOKIE_ALL_XCEED_DOMAIN = '.xceed';

export const COOKIE_SELECTED_TEAM = 'xceed-pro-selected-team-id';

export const REFRESH_TOKEN_EXPIRATION_TIME = import.meta.env.VITE_REFRESH_TOKEN_EXPIRATION_TIME;
